import {useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

import { styles } from '../styles';
import { EarthCanvas } from './canvas';
import { slideIn } from '../utils/motion';

export const Contact = () => {
  
  
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_auwp62s', 'template_v47owws', form.current, '3Pv3Jw0Qq4YGEuwgR')

      .then((result) => {
        
        console.log(result.text);
        e.target.reset();
        alert("Thank you. I will respond you back as soon as possible.");    

      }, (error) => {
          console.log(error.text);
      });
  };

  return (
<div className={`xl:mt-12 flex xl:flex-row flex-col-reverse gap-10 overflow-hidden`}>
               <motion.div
                variants={slideIn("left", "tween", 0.2, 3)}
                className='flex-[0.75] bg-black-80 p-8 rounded-2xl'
            >
                <p className={styles.sectionSubText} style={{ "padding-left": 0, "list-style": "none", "font-size": "30px", "margin-bottom": "7px", "margin-top": "0px", "text-align": "center" }}>Get in touch</p>
                <h3 className={styles.sectionHeadText} style={{ "padding-left": 0, "list-style": "none", "font-size": "30px", "margin-bottom": "7px", "margin-top": "0px", "text-align": "center" }}>Contact.</h3>

    <form ref={form} onSubmit={sendEmail}>
      <label className='flex flex-col'>
                        <span className='text-white
                        font-medium mb-2'>Your Name</span>
                        <input 
                        type="text"
                        name="name"
                        value={form.name}
                        // onChange={handleChange}
                        placeholder="Alex Doe"
                        className='bg-tertiary py-3 px-6
                        placeholder:text-secondary 
                        text-white 
                        rounded-lg outline-none
                        border-none font-medium'
                        />
                    </label>
                    <label className='flex flex-col'>
                        <span className='text-white
                        font-medium mb-2'>Your Email Address</span>
                        <input 
                        type="email"
                        name="email"
                        value={form.email}
                        // onChange={handleChange}
                        placeholder="jane@example.com"
                        className='bg-tertiary py-3 px-6
                        placeholder:text-secondary 
                        text-white 
                        rounded-lg outline-none
                        border-none font-medium'
                        />
                    </label>
                    <label className='flex flex-col'>
                        <span className='text-white
                        font-medium mb-2'>Your message</span>
                        <textarea
                        rows={7} 
                        name="message"
                        value={form.message}
                        // onChange={handleChange}
                        placeholder="Please, leave a message here"
                        className='bg-tertiary py-3 px-6
                        placeholder:text-secondary 
                        text-white 
                        rounded-lg outline-none
                        border-none font-medium'
                        />
                    </label>
      <input type="submit" value="Send" />
    </form>

    </motion.div>

    <motion.div
                variants={slideIn("right", "tween", 0.2, 1)}
                className="xl:flex-1 xl:h-auto md:h-[550px] h-[350px]">
                <EarthCanvas />
    </motion.div>
        </div>
  );
};